<template>
  <div id="theNavBar" class="sticky-top">
    <nav class="navbar navbar-dark fixed-top bg-azure-dark navbar-expand-md p-0">
      <router-link tag="a" :to="{ name: (!!$store.getters.type) ? $store.getters.type : 'SecurityHome' }" class="navbar-brand azure-light ml-md-5 p-0 pl-3">
        <img src="@/assets/logo-light-sm.svg" alt="Azurity Beveiliging Logo" />
      </router-link>
      <button class="navbar-toggler mr-3" type="button" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Navigatie Menu" @click="isShow = !isShow">
        <span class="navbar-toggler-icon"></span>
      </button>

      <transition name="slide">
        <div class="collapse navbar-collapse bg-azure-dark" id="navbarSupportedContent" :class="{'show' : isShow, 'small': $store.getters.isSmall}" v-if="($store.getters.isSmall) ? isShow : true">
            <ul class="navbar-nav mr-auto" >
              <!--
              <template v-if="$store.getters.isAuthenticated">
                <template v-if="type == 'client'">
                  <li class="nav-item  ml-5" @click="isShow = false" >
                    <router-link :to="{ name: 'ClientAssignments' }" tag="a" class="nav-link azure-light">Opdrachten</router-link>
                  </li>
                  <li class="nav-item  ml-5" @click="isShow = false">
                    <router-link :to="{ name: 'ClientPlanning' }" tag="a" class="nav-link azure-light">Planning</router-link>
                  </li>
                  <li class="nav-item  ml-5" @click="isShow = false" v-if="$store.getters.user.isSecurityCompany">
                    <router-link :to="{ name: 'ClientActivities'}" tag="a" class="nav-link azure-light">Werkzaamheden Aanmelden</router-link>
                  </li>
                  <li class="nav-item  ml-5" @click="isShow = false" hidden>
                    <router-link :to="{ name: 'ClientProgress' }" tag="a" class="nav-link azure-light">Voortgang</router-link>
                  </li>
                </template>
                <template v-if="type == 'professional'">
                  <li class="nav-item  ml-5"  @click="isShow = false">
                    <router-link :to="{ name: 'ProfessionalAssignments' }" tag="a" class="nav-link azure-light">Mijn Opdrachten</router-link>
                  </li>
                  <li class="nav-item  ml-5" @click="isShow = false">
                    <router-link :to="{ name: 'ProfessionalCalendar' }" tag="a" class="nav-link azure-light">Kalender</router-link>
                  </li>
                  <li class="nav-item  ml-5" @click="isShow = false" hidden>
                    <router-link :to="{ name: 'ProfessionalProgress' }" tag="a" class="nav-link azure-light">Voortgang</router-link>
                  </li>
                  <li class="nav-item  ml-5" @click="isShow = false">
                    <router-link :to="{ name: 'ProfessionalWebshop' }" tag="a" class="nav-link azure-light">Webshop</router-link>
                  </li>
                </template>
              </template>
              <template v-else>
              -->
                <li class="nav-item ml-5" @click="isShow = false">
                  <router-link :to="{ name: 'SecurityAbout' }" tag="a" class="nav-link azure-light">Beveiligingsbedrijf</router-link>
                </li>
                <li class="nav-item ml-5" @click="isShow = false">
                  <router-link :to="{ name: 'Software' }" tag="a" class="nav-link azure-light">Software</router-link>
                </li>
                <li class="nav-item ml-5" @click="isShow = false">
                  <router-link :to="{ name: 'SecurityFAQ' }" tag="a" class="nav-link azure-light">FAQ</router-link>
                </li>
                <li class="nav-item ml-5" @click="isShow = false" hidden>
                  <a class="nav-link azure-light" href="#">Meer</a>
                </li>
              <!--</template>-->
            </ul>
            <ul class="navbar-nav ml-auto">
              <!--
              <template v-if="$store.getters.isAuthenticated">
                <li :class="['nav-item ml-5',{ 'mr-5': $store.getters.isSmall }]" @click="isShow = false">
                  <router-link 
                  :to="{ name: this.type == 'professional' ? 'ProfessionalProfileOverview' : 'ClientProfileOverview' }" 
                  tag="a" 
                  class="nav-link azure-light">{{userName}}</router-link>
                </li>
                <li :class="['nav-item ml-5 mr-5']" @click="isShow = false">
                  <button :class="['btn btn-outline-azure', { 'btn-wide mt-3 mb-3 btn-lg': $store.getters.isSmall }]" type="button" @click="logOff" title="Uitloggen">
                      Uitloggen
                  </button>
                </li>
              </template>
              <template v-else>
              -->
                <li class="nav-item ml-5" @click="isShow = false">
                  <a href="https://app.azurity.nl/account/login" target="_blank" class="nav-link azure-light">Inloggen</a>
                </li>
                <li class="nav-item ml-5 " @click="isShow = false">
                  <a href="https://app.azurity.nl/account/register" target="_blank" class="nav-link azure-light">Aanmelden</a>
                </li>
                <li class="nav-item ml-5 mr-4 whatsapp">
                  <a href="https://wa.me/31640000933" rel="noopener" title="WhatsApp" class="nav-link azure-light" target="_blank"><font-awesome-icon :icon="['fab', 'whatsapp']"></font-awesome-icon>&nbsp;06-40000933</a>
                </li>
              <!--</template>-->
            </ul>
        </div>
      </transition>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'TheNavBar',
  data() {
    return {
      isShow: false
    }
  },
  mounted() {
    if(window.outerWidth >= 768)
    {
      this.isShow = true;
    }

    window.addEventListener('resize', (ev) => {
      if(window.outerWidth >= 768)
      {
        this.isShow = true;
      } else 
      {
        this.isShow = false;
      }
    })
  },
  methods: {
    showMenu() {
      document.getElementById("navbarSupportedContent").classList.toggle('show')
    },
    logOff() {
      this.$store.dispatch('AUTH_LOGOUT');
      this.$router.push({ name: "Login" });
    }
  },
  computed: {
    type() {
      if(this.$store.getters.type)
        return this.$store.getters.type.toLowerCase();
    },
    userName() {
      if(this.type == "professional")
      {
        if(!this.$store.getters.user.firstName && !this.$store.getters.user.lastName)
          return this.$store.getters.user.userName;
        return ((this.$store.getters.user.firstName) ? this.$store.getters.user.firstName : '') + ' ' + ((this.$store.getters.user.lastName) ? this.$store.getters.user.lastName : '');
      }

      if(this.type == "client")
        if(!this.$store.getters.user.company)
          return this.$store.getters.user.userName;
        return this.$store.getters.user.company;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

#navbarSupportedContent.small
{
  position: absolute;
  top:70px;
  width:100%;
}

#navbarSupportedContent.small li
{
  font-size: 1.5rem;
}
.navbar {
  height: 70px;
  font-size: calc(12px + 0.4vw);
  font-weight: bold;
}
.navbar a {
  text-decoration: none;
}
.navbar-brand:hover,
.nav-link:hover
{
  color: #fff;
}

.navbar-dark .navbar-nav .nav-link {
  color: $lightColor
}

.navbar-dark .navbar-nav .nav-link:hover {
  color: #fff;
}

.slide-enter-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 100px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}

</style>
